module.exports = __webpack_public_path__ + "media/img/features/dark-theme-large-de916e4211936cf4747a062d78f57ea3.png";